import { defaultColorPalette } from '@/constants/brandingThemes';
import { ExternalBankAccountStatus } from '@/types/externalAccounts';
import { generateExternalAccountStatusLabel } from '@/utils/externalBankAccounts';
import { Box, Typography } from '@mui/material';

type ExternalAccountStatusLabelProps = {
  status: ExternalBankAccountStatus;
  isSmall?: boolean;
};

export default function ExternalAccountStatusLabel({
  status,
  isSmall = false,
}: ExternalAccountStatusLabelProps) {
  const isInactive =
    status === ExternalBankAccountStatus.DECLINED ||
    status === ExternalBankAccountStatus.DELETED;
  const isAwaiting =
    status === ExternalBankAccountStatus.AWAITING_BANK_ADDRESS ||
    status === ExternalBankAccountStatus.AWAITING_BANK_NAME ||
    status === ExternalBankAccountStatus.AWAITING_CODE ||
    status === ExternalBankAccountStatus.AWAITING_E_SIGN;
  const statusColor = isInactive
    ? defaultColorPalette.error
    : isAwaiting
      ? defaultColorPalette.tertiary
      : defaultColorPalette.success;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          backgroundColor: statusColor,
          height: isSmall ? 10 : 13,
          width: isSmall ? 10 : 13,
          borderRadius: '50%',
          marginRight: '5px',
          marginTop: '-3px',
        }}
      />
      <Typography variant={isSmall ? 'caption' : 'body1'}>
        {generateExternalAccountStatusLabel(status)}
      </Typography>
    </Box>
  );
}
